// BRN-2118 (AC1, AC7) — per-env derivation of the brain-agents embed origin from BRAIN's OWN public
// hostname. Replaces the previous `host.includes('qa')` qa/prod binary in environment.prod.ts with a
// STRUCTURAL derivation that resolves qa, prod, AND any future commissioned environment
// automatically, with no per-env branch and no hardcoded per-env origin.
//
// BRAIN is served per tenant at `<tenant>.<web-host-prefix>brain.gridwatchems.com` (qa:
// `<tenant>.qa.brain.gridwatchems.com`; prod apex: `<tenant>.brain.gridwatchems.com`) and its agents
// surface at the sibling `<web-host-prefix>agents.gridwatchems.com`. So the origin is derived by
// dropping the single leading tenant label and swapping the product label `brain` -> `agents`:
//   santafenm.qa.brain.gridwatchems.com -> https://qa.agents.gridwatchems.com
//   santafenm.brain.gridwatchems.com    -> https://agents.gridwatchems.com
//
// ASSUMPTION (flagged for operator confirmation — see BRN-2118 report): BRAIN is always reached at
// `<tenant>.[<prefix>.]brain.gridwatchems.com` with EXACTLY ONE leading tenant label. If BRAIN can be
// reached tenant-LESS (`brain.gridwatchems.com` with no tenant), the leading-label drop over-drops
// and the prefix must instead be injected from the registry `web_host_prefix`
// (brain-infrastructure envs/environments.json) as config, rather than derived from the host.

/** Pure, unit-testable: no `window` access, so the transform is provable in isolation. */
export function deriveAgentsEmbedUrl(hostname: string): string {
  return 'https://' + hostname.replace(/^[^.]+\./, '').replace(/(^|\.)brain\./, '$1agents.');
}
